import { motion } from "framer-motion";
import { Star } from "lucide-react";

function Stars({ rating, className = "" }) {
  return (
    <div className={`flex gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star
          key={n}
          size={16}
          className={n <= Math.round(rating) ? "fill-[#F5A623] text-[#F5A623]" : "fill-stone-200 text-stone-200"}
        />
      ))}
    </div>
  );
}

export default function Reviews({ content }) {
  const reviews = content.reviews || [];
  return (
    <section id="resenas" className="relative py-24 md:py-36 bg-[#f9f6f0]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-[#da251d] uppercase tracking-[0.3em] text-xs font-semibold mb-4">Lo que dicen</p>
            <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tight leading-none">
              Reseñas de nuestros clientes
            </h2>
          </div>
          <div className="flex items-center gap-4">
            <span className="font-display text-5xl md:text-6xl font-bold text-[#1a1a1a]" data-testid="rating-average">
              {content.rating_average}
            </span>
            <div>
              <Stars rating={parseFloat(content.rating_average) || 5} />
              <p className="text-sm text-[#57534e] mt-1">{content.rating_count} reseñas en Google</p>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {reviews.map((r, i) => (
            <motion.figure
              key={r.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="bg-white border border-stone-200 p-6 flex flex-col shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
              data-testid={`review-card-${i}`}
            >
              <Stars rating={r.rating} className="mb-4" />
              <blockquote className="text-[#1a1a1a] leading-relaxed flex-1">"{r.text}"</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#da251d] text-white font-semibold">
                  {r.name?.[0] || "?"}
                </span>
                <div>
                  <p className="font-semibold text-sm">{r.name}</p>
                  <p className="text-xs text-stone-400">{r.date}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        {content.google_reviews_url && (
          <div className="mt-12 text-center">
            <a
              href={content.google_reviews_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-reviews-link"
              className="inline-flex items-center gap-2 rounded-full border border-stone-300 font-semibold px-8 py-4 transition-colors duration-200 hover:border-[#da251d] hover:text-[#da251d]"
            >
              Ver todas las reseñas en Google
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
